import Link from "next/link";

import {
  AuthorInterface,
  ClassName,
} from "@/helpers/pageHelpers/Common/interface";
import Typography from "@/components/Typography";
import Avatar from "@/components/Avatar";
import FollowAuthorButton from "@/components/FollowAuthorButton";
import { applicationRoutes } from "@/helpers/applicationRouting";

import styles from "./Hosts.module.scss";

interface Hosts {
  hosts?: AuthorInterface[];
  className?: ClassName;
}

export const Hosts: React.FC<Hosts> = ({ hosts, className }) => {
  if (!hosts) {
    return <></>;
  }

  return (
    <div className={className}>
      <Typography variant="h4" component="h6" className={styles.heading}>
        Prowadzący
      </Typography>

      <ul className={styles.list}>
        {hosts.map((host) => (
          <li key={host.id} className={styles.host}>
            <Link
              href={{
                pathname: `${applicationRoutes.AUTHOR}[slug]`,
              }}
              as={applicationRoutes.AUTHOR + host.slug}
            >
              <a className={styles.link}>
                <Avatar
                  src={host.avatar.url}
                  alt={host.name}
                  size="medium"
                  wrapperClassName={styles.avatar}
                />

                <Typography variant="medium" className={styles.name}>
                  {host.name}
                </Typography>
              </a>
            </Link>

            <FollowAuthorButton
              followed={host.followed}
              slug={host.slug}
              variant="round"
              size="small"
              className={styles.bookmark}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Hosts;
